<template>
  <v-footer 
    :inset="footer.inset"
    height="auto"
    class="px-0 pt-0 grey lighten-3"
    app
  >
    <span class="px-3 footer-white--text caption">
      <img style="width: 65px; vertical-align: text-bottom;" :src="footer_icon"/> Copyright &copy; {{ new Date().getFullYear() }} All rights reserved.</span>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      footer_icon: require('@/assets/img/logo/CD_logo.svg'),
      footer: {
        inset: true
      }
    })
  }
</script>

<style scoped>
.application .theme--light.v-footer, .theme--light .v-footer {
    background: white;
    color: #c2c2c2;
}

.footer-white--text img{
    width: 20px;
    vertical-align: baseline;
    margin-right: 5px;
}
.footer-white--text {
    color: rgba(0, 0, 0, 0.80)!important;
    width: 100%;
    margin: 0px auto;
    /* border-top: 1px solid #C2C2C2;     */
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
}
</style>
